import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ContractLotStandardizedComponent } from "./contract-lot-standardized/contract-lot-standardized.component";

const routes: Routes = [{
  path: "", component: ContractLotStandardizedComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContractLotStandardizedRoutingModule { }
